import request from 'admin-ng/util/request-promise';
import {AUDIT_LOGS} from '.';

export const all = (resource, id, params) =>
  request(`${AUDIT_LOGS}${resource}/${id}`, 'get', params);
